import { useState } from "react";
import "./city-location-card.scss";
import plusIcon from "../../assets/plusIcon.svg";
import minusIcon from "../../assets/minusIcon.svg";

const CityLocationCard = ({
  expandedCityIndex,
  setExpandedCityIndex,
  locationData,
  setSelectedLocalities,
  selectedLocalities,
}) => {
  const toggleCityExpansion = (index) => {
    setExpandedCityIndex(expandedCityIndex === index ? null : index);
  };

  const handleCityCheckboxChange = (city, allLocalities) => {
    setSelectedLocalities((prevSelected) => {
      const cityAlreadySelected = prevSelected.some(
        (item) => item.city === city
      );
      
      if (cityAlreadySelected) {
        // If city is already selected, deselect the city and all its localities
        return prevSelected.filter((item) => item.city !== city);
      } else {
        // If city is not selected, select the city and all its localities
        const allLocalityNames = allLocalities.map((loc) => loc.name).join(",");
        return [...prevSelected, { city, name: allLocalityNames }];
      }
    });
  };

  // const handleCityCheckboxChange = (city) => {
  //   setSelectedLocalities((prevSelected) => {
  //     const cityAlreadySelected = prevSelected.some(
  //       (item) => item.city === city
  //     );
  //     if (cityAlreadySelected) {
  //       return prevSelected.filter((item) => item.city !== city);
  //     } else {
  //       return [...prevSelected, { city, name: "All" }];
  //     }
  //   });
  // };

  // const handleLocalityCheckboxChange = (city, locality, allLocalities) => {
  //   setSelectedLocalities((prevSelected) => {
  //     return prevSelected.map((item) => {
  //       if (item.city === city) {
  //         const localities = item.name ? item.name.split(",") : [];
  //         const localityAlreadySelected = localities.includes(locality);

  //         let updatedLocalities;
  //         if (locality === "All") {
  //           updatedLocalities = localityAlreadySelected
  //             ? ""
  //             : allLocalities.map((loc) => loc.name).join(",");
  //         } else {
  //           updatedLocalities = localityAlreadySelected
  //             ? localities.filter((name) => name !== locality).join(",")
  //             : [...localities, locality].join(",");
  //         }

  //         return { ...item, name: updatedLocalities };
  //       }
  //       return item;
  //     });
  //   });
  // };

  const handleLocalityCheckboxChange = (city, locality, allLocalities) => {
    setSelectedLocalities((prevSelected) => {
      return prevSelected.map((item) => {
        if (item.city === city) {
          const localities = item.name ? item.name.split(",") : [];
          const localityAlreadySelected = localities.includes(locality);
  
          let updatedLocalities;
  
          if (locality === "All") {
            // If "All" is selected/deselected
            updatedLocalities = localityAlreadySelected
              ? ""  // Deselect all
              : allLocalities.map((loc) => loc.name).join(",");  // Select all
          } else {
            if (localityAlreadySelected) {
              // Deselect a specific locality
              updatedLocalities = localities.filter((name) => name !== locality).join(",");
              
              // Check if "All" was previously selected, remove it when deselecting any other locality
              if (localities.includes("All")) {
                updatedLocalities = updatedLocalities.replace("All,", "").replace(",All", "");
              }
            } else {
              // Select a specific locality
              updatedLocalities = [...localities, locality].join(",");
              
              // If all specific localities are selected, mark "All" as selected
              if (updatedLocalities.split(",").length === allLocalities.length) {
                updatedLocalities = "All";
              }
            }
          }
  
          return { ...item, name: updatedLocalities };
        }
        return item;
      });
    });
  };
  

  return (
    <div className="cityLocationMainContainer">
      {locationData.map((cityData, cityIndex) => (
        <div key={cityIndex} className="CityAndLocationCard">
          <div className="citySection">
            <div className="cityNameSelect">
              <div className="roundCheckbox">
                <input
                  type="checkbox"
                  id={`city-checkbox-${cityIndex}`}
                  checked={selectedLocalities.some(
                    (item) => item.city === cityData.city
                  )}
                  onChange={() => handleCityCheckboxChange(cityData.city, cityData.locations)}
                />
                <label htmlFor={`city-checkbox-${cityIndex}`}></label>
              </div>
              <div
                className="city-text"
                onClick={() => toggleCityExpansion(cityIndex)}
              >
                {cityData.city}
              </div>
            </div>
            <div onClick={() => toggleCityExpansion(cityIndex)}>
              {expandedCityIndex === cityIndex ? (
                <img className="iconImgStyle" src={minusIcon} alt="close" />
              ) : (
                <img className="iconImgStyle" src={plusIcon} alt="open" />
              )}
            </div>
          </div>
          <div
            className={`locationSection ${
              expandedCityIndex === cityIndex ? "selected" : ""
            }`}
          >
            {cityData.locations.map((locality, index) => (
              <div key={index} className="location-item">
                <input
                  type="checkbox"
                  id={`checkbox-${cityIndex}-${index}`}
                  checked={selectedLocalities.some(
                    (item) =>
                      item.city === cityData.city &&
                      item.name.split(",").includes(locality.name)
                  )}
                  onChange={() =>
                    handleLocalityCheckboxChange(
                      cityData.city,
                      locality.name,
                      cityData.locations
                    )
                  }
                />
                <label htmlFor={`checkbox-${cityIndex}-${index}`}>
                  {locality.name}
                </label>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CityLocationCard;
